import { jsxs as i, jsx as s } from "react/jsx-runtime";
import o from "./chunk501.js";
import l from "clsx";
import { IconSmallAttention as c } from "./chunk63.js";
import { IconSmallClose as m } from "./chunk40.js";
var n = /* @__PURE__ */ ((r) => (r.Success = "success", r.Error = "error", r.Pending = "pending", r))(n || {});
const D = ({ children: r, type: e, onClose: t }) => /* @__PURE__ */ i("div", { className: l(o.primaryAlert, o[e]), children: [
  /* @__PURE__ */ s(
    c,
    {
      className: o.alertIcon,
      width: "20",
      height: "20",
      fill: "#5D5D5D"
    }
  ),
  /* @__PURE__ */ s("span", { className: o.alertText, children: r }),
  typeof t == "function" && /* @__PURE__ */ s(
    m,
    {
      className: o.closeIcon,
      width: "20",
      height: "20",
      fill: "#5D5D5D",
      onClick: t
    }
  )
] });
export {
  D as Alert,
  n as AlertType
};
